import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import { EditOutlined } from '@mui/icons-material'

import { makeStyles } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeGetRequest } from '../../../../_state/helpers/api'
import { configWithAuth } from '../../../../_state/helpers'
import { AddOutlined, LanguageOutlined } from '@material-ui/icons'
import { Button } from '@mui/material'
import { CapeeshColors } from '../../../../assets/ColorPalette'
import IconButton from '@material-ui/core/IconButton'
import WestIcon from '@mui/icons-material/West'
import { CapeeshSizes } from '../../../../assets/SizePresets'

const useStyles = makeStyles((theme) => ({
    main: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        width: '100%',
        minHeight: '180px',
    },
    sideBar: {
        width: CapeeshSizes.CreatorSideBar,
        padding: '32px',
    },
    sideBarText: {
        fontFamily: 'Rubik',
        fontsize: '16px',
        fontStyle: 'normal',
        fontWeight: 500,
        color: CapeeshColors.DeepBlue,
    },
    topicInfoContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '32px',
    },
    topicImage: {
        width: '320px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
    },
    topicImageContent: {
        width: '320px',
        position: 'relative',
    },
    topicDataContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        justifyContent: 'center',
    },
    topicTopHeader: {
        fontFamily: 'Rubik',
        fontsize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    topicName: {
        fontFamily: 'Rubik',
        fontsize: '32px',
        fontStyle: 'normal',
        fontWeight: 500,
    },
    topicDescription: {
        fontFamily: 'Rubik',
        fontsize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
    },
    newLessonButton: {
        color: 'white',
        background: CapeeshColors.Primary600,
        height: '40px',
        marginTop: '16px',
    },
    languagesButton: {
        height: '40px',
        marginTop: '16px',
        background: CapeeshColors.Gray100,
    },
    floatingEditButton: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        height: '40px',
        marginTop: '16px',
        background: CapeeshColors.Gray100,
    },
}))

const TopicLessonOrderHeader = ({
    topicData,
    organization,
    onCreateNewLesson,
    onShowLanguageModal,
    onBackToCourseGroup,
    courseGroupId,
    showActionButtons,
    onEditTopic,
    setImageBlob,
}) => {
    const classes = useStyles()

    const [currentTopicImageFileReferenceId, setCurrentTopicImageFileReferenceId] = useState('')
    const [topicImageData, setTopicImageData] = useState(false)

    const fetchImage = () => {
        if (topicData?.imageFileReferenceId) {
            makeGetRequest(
                `admin/organization/${organization.selectedOrganization}/image/file/reference/${topicData.imageFileReferenceId}/base64`,
                configWithAuth()
            )
                .then((result) => {
                    setTopicImageData(result.data)
                    setImageBlob(result.data)
                    setCurrentTopicImageFileReferenceId(topicData.imageFileReferenceId)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
    useEffect(() => {
        fetchImage()
    }, [])
    useEffect(() => {
        if (topicData && topicData?.imageFileReferenceId !== currentTopicImageFileReferenceId) {
            fetchImage()
        }
    }, [topicData])

    return (
        <div className={classes.main}>
            <div className={classes.sideBar}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        cursor: 'pointer',
                    }}
                    onClick={(event) => onBackToCourseGroup(event)}>
                    {courseGroupId && (
                        <IconButton
                            sx={{
                                fontSize: '24px',
                                display: 'center',
                                alignItems: 'left',
                                marginLeft: '4px',
                                justifyContent: 'center',
                                height: '30px',
                                color: 'gray',
                            }}>
                            <WestIcon sx={{ fontSize: '24px' }} />
                        </IconButton>
                    )}

                    <Typography className={classes.sideBarText}>
                        <FormattedMessage id={'create.topic.go.back.to.course'} defaultMessage={'Go to topics'} />
                    </Typography>
                </div>
            </div>
            <div className={classes.topicInfoContainer}>
                <div className={classes.topicImage}>
                    <div className={classes.topicImageContent}>
                        {topicImageData ? (
                            <div style={{ marginTop: '20px' }} key={topicImageData}>
                                <img
                                    style={{
                                        borderRadius: '10px',
                                    }}
                                    src={topicImageData}
                                    width={'320px'}></img>
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '21%',
                                        left: '12%',
                                        transform: 'translateY(-21%) translateX(-12%)',
                                        zIndex: 1,
                                    }}>
                                    <Button
                                        className={classes.languagesButton}
                                        style={{
                                            textTransform: 'none',
                                            color: CapeeshColors.Gray900,
                                            background: CapeeshColors.Gray100,
                                            opacity: '0.8',
                                        }}
                                        variant={'contained'}
                                        onClick={() => onEditTopic()}>
                                        <EditOutlined
                                            sx={{
                                                marginRight: '8px',
                                                fontSize: '15px',
                                            }}
                                        />
                                        <FormattedMessage
                                            id="create.topic.lesson.order.button.edit.topic.title"
                                            defaultMessage={'Edit topic'}
                                        />
                                    </Button>
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    height: '190px',
                                    width: '320px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'white',
                                    borderRadius: '10px',
                                }}>
                                {topicData && !topicData.imageFileReferenceId && (
                                    <Typography
                                        variant="h4"
                                        style={{
                                            fontFamily: 'Lato',
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            fontSize: '16px',
                                            lineHeight: '23px',
                                            background: 'white',
                                            marginTop: '20px',
                                            padding: '20px',
                                        }}>
                                        <FormattedMessage
                                            id="create.topic.no.image.added"
                                            defaultMessage={'No image has been added to the topic.'}
                                        />
                                    </Typography>
                                )}

                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '21%',
                                        left: '12%',
                                        transform: 'translateY(-21%) translateX(-12%)',
                                        zIndex: 1,
                                    }}>
                                    <Button
                                        className={classes.languagesButton}
                                        style={{
                                            textTransform: 'none',
                                            color: CapeeshColors.Gray900,
                                            background: CapeeshColors.Gray100,
                                            opacity: '0.8',
                                        }}
                                        variant={'contained'}
                                        onClick={() => onEditTopic()}>
                                        <EditOutlined
                                            sx={{
                                                marginRight: '8px',
                                                fontSize: '15px',
                                            }}
                                        />
                                        <FormattedMessage
                                            id="create.topic.lesson.order.button.edit.topic.title"
                                            defaultMessage={'Edit topic'}
                                        />
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={classes.topicDataContainer}>
                    <Typography className={classes.topicTopHeader}>
                        <FormattedMessage id={'globalwords.topic'} defaultMessage={'Topic'} />
                    </Typography>
                    <Typography className={classes.topicName} variant={'h3'}>
                        {topicData?.name}
                    </Typography>
                    <Typography className={classes.topicDescription}>{topicData?.description}</Typography>
                    {showActionButtons && (
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'left', gap: '16px' }}>
                            <Button
                                className={classes.newLessonButton}
                                style={{
                                    textTransform: 'none',
                                }}
                                variant={'contained'}
                                onClick={() => onCreateNewLesson()}>
                                <AddOutlined
                                    sx={{
                                        marginRight: '15px',
                                        fontSize: '15px',
                                        color: 'white',
                                    }}
                                />
                                <FormattedMessage
                                    id="create.topic.lesson.order.button.new.lesson.title"
                                    defaultMessage={'Create new lesson'}
                                />
                            </Button>

                            <Button
                                className={classes.languagesButton}
                                style={{
                                    textTransform: 'none',
                                    color: CapeeshColors.Gray900,
                                    background: CapeeshColors.Gray100,
                                }}
                                variant={'contained'}
                                onClick={() => onShowLanguageModal()}>
                                <LanguageOutlined
                                    style={{ marginRight: '8px' }}
                                    sx={{
                                        fontSize: '15px',
                                    }}
                                />
                                <FormattedMessage
                                    id="create.topic.lesson.order.button.view.topic.language.title"
                                    defaultMessage={'Translations'}
                                />
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

TopicLessonOrderHeader.propTypes = {}

const mapStateToProps = (state) => {
    return {
        organization: state.organization,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TopicLessonOrderHeader)
